import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCommentQuote } from "@nnr/fontawesome-sharp-light/icons/sharp/light";
import { useRangeMentionSignal } from "../../hooks/use-mention-signal";
import { useTiptapEditor } from "../../hooks/use-tiptap-editor";
import { Button } from "../ui/button";

export function AiButton() {
  const editor = useTiptapEditor();
  const { trigger } = useRangeMentionSignal();

  function handleSelectRange() {
    const from = editor?.state.selection.from;
    const to = editor?.state.selection.to;

    if (!from || !to) return;

    trigger({ from, to });
  }

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={handleSelectRange}
      title={"TEMP: Send to Chat"}
    >
      <FontAwesomeIcon icon={faCommentQuote} />
    </Button>
  );
}
